import { getUnverifiableRuntimeDockerPublicEnvs } from '../../env/getEnvs'

export const clientVersionHeaders = {
  'x-graphql-client-name': 'webapp',
  'x-graphql-client-version': getUnverifiableRuntimeDockerPublicEnvs().NEXT_PUBLIC_GIT_SHA || 'local',
}
